module.exports = __webpack_public_path__ + "img/Flag_of_Mauritania.838def2c.svg";